import { render, staticRenderFns } from "./positionDetails.vue?vue&type=template&id=27ae043a&scoped=true&"
import script from "./positionDetails.vue?vue&type=script&lang=js&"
export * from "./positionDetails.vue?vue&type=script&lang=js&"
import style0 from "./positionDetails.vue?vue&type=style&index=0&id=27ae043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae043a",
  null
  
)

export default component.exports